import { Button, Dialog, Typography } from '@pwskills/rachnaui';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';

type PaymentModalProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const PaymentSuccessModal = (props: PaymentModalProps) => {
  const { open, setOpen } = props;
  const masterclassDetails = useMasterclassDescriptionStore((state) => state.masterclassDetails);

  const joinCommunity = () => {
    window.open(masterclassDetails.communityLink);
  };

  return (
    <Dialog
      open={open}
      closeModal={() => setOpen(false)}
      closeEnable
      isOutSideClick
      className="z-[99999] rounded-xl large:!w-[42%] regular:!w-[60%]"
    >
      <div className="!p-[32px] regular:!px-[56px] regular:!py-8 large:!px-[140px] large:!py-14">
        <div className="flex flex-col gap-4  medium:gap-9 justify-center items-center">
          <img
            src="/images/masterclassDescription/transactionSuccess.gif"
            alt="success"
            className="w-[200px] h-[200px]"
          />
          <Typography component="body-regular" variant="bold" className="text-center text-gray-900">
            You have successfully registered for this masterclass
          </Typography>
          {masterclassDetails.communityLink && (
            <>
              <Typography component="body-tiny">To get latest updates*</Typography>
              <Button
                className="pointer bg-gray-850 hover:bg-gray-650"
                onClick={joinCommunity}
                size="medium"
                startIcon={
                  <img
                    src="/images/masterclassDescription/community.png"
                    alt="community"
                    className="w-8 h-8"
                  />
                }
              >
                Join our Community Group
              </Button>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
};
export default PaymentSuccessModal;
